/**
 * 执行记录详情
 * @type {{}}
 */
import Vue from "vue";
import { Input, Icon, Select, Option, Message, Table, Page, Modal,Button,Tabs,TabPane,Spin,Poptip,Drawer,Dropdown,DropdownMenu,DropdownItem,Breadcrumb,BreadcrumbItem,Checkbox,CheckboxGroup} from "view-design";
import {
    recordInfoColumns,
    recordModalListColumns,
    getRecordInfoService,
    getImageUrlService,
    getRecordVideoListService, batchInputRecordColumns,
    getRecordOperationAllService, getRecordExportService
} from "@/service/workflow-service";
import { mapMutations, mapState } from "vuex";
Vue.component('Input', Input);
Vue.component('Icon', Icon);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Table', Table);
Vue.component('Page', Page);
Vue.component('Modal', Modal);
Vue.component('Button', Button);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('Spin', Spin);
Vue.component('Poptip', Poptip);
Vue.component('Drawer', Drawer);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('BreadcrumbItem', BreadcrumbItem);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Checkbox', Checkbox);
import ViewImage from '@/components/ViewImage/viewImage.vue'
import { downloadFile } from "@/utils/tools";
const RecordInspectionInfo = {
    name:'RecordInspectionInfo',
    components:{ ViewImage },
    computed: {
        ...mapState({
            taskId: state => state.system.taskId, //任务id
            taskList: state => state.system.taskList, //任务数据
        }),
    },
    data() {
        return {
            recordLoading:false, //loading
            recordVideoListLoading:false, //loading
            recordVideoLoading:false, //loading
            recordModalVisible:false, //图片modal
            voiceModalVisible:false,
            recordModalListVisible:false, //批量操作查看记录弹框
            batchInputListVisible:false, //批量输入查看记录弹框
            recordModalTitle:'', //modal title
            menuVisible:true,
            recordInfoColumns:recordInfoColumns, //显示字段
            recordModalListColumns:recordModalListColumns, //批量操作记录列表显示字段
            batchInputRecordColumns:batchInputRecordColumns, //批量输入显示数据
            recordInfoArray:[], //数据集合
            recordSelectObj:{}, //选择的视频数据
            recordVideoArray:[], //视频列表数据
            recordInfoVisible:false, //任务信息弹框可显示
            tabStatus:0,
            stepFeedbackVisible:false, //步骤反馈弹框可显示
            quickFeedbackVisible:false, //快捷反馈弹框可显示
            viewImageVisible:false,
            recordSearchVisible:false,
            recordSearchList:[],
            recordSearchArray:[],
            recordSelectAllVisible:false,
            recordSelectExportAllVisible:false,
            imageName:'',
            quickList:[],
            voiceList:[],
            videoList:[],
            voiceInputKey:'',
            audioUrl:'',
            quickNumber:1,
            playIndex:0,
            recordInfoObj:[], //任务信息
            videoKey:0,
            imageSrc:'',
            videoSrc:'',
            stepFeedbackObj:{},
            audioSrc:'', //语音文件地址
            audioText:'', //语音文件文本
            audioVisible:true,
            inputTypeCode:'', //输入类型
            unitType:'', //单位
            batchArray:[], //批量操作数据集
            batchInputArray:[], //批量输入数据集
            flowId:'',
            flowDel:0,
            checkAll:false,
            recordModalExportVisible:false,
            recordModalLoading:false,
            imageBigLookVisible:false, //图册查看大图可显示
            imageObj:{},
            imageRatio:100,
            imageBigNumber:0,
            imageBigArray:[], //图册数据
            imageWidth:0,
            imageHeight:0,
            imageLeft:0,
            imageTop:0,
            currentX:0, //记录落点的x坐标
            currentY:0, //记录落点的Y坐标
            offsetWidth:0, //记录滚动内容宽度
            imageBigActive:0, //大图定位值
            deviceTabsNumber:1,
            imageLoading:false,
            drawing:false, //是否绘制
            recordModalExportList:[{
                name:'查看反馈',
                value:3,
                type:0
            },
                {
                    name:'作业标准',
                    value:4,
                    type:0
                },
                {
                    name:'用户操作',
                    value:5,
                    type:0
                },
                {
                    name:'起止时间',
                    value:6,
                    type:0
                }],
            recordInfoParams:{ //提交的数据集
                currentPage: 1,  //当前页
                displayNumber:20 // 显示条数
            },
            exportArray:{}
        }
    },
    created() {
        this.onRecordInfo().then()
        this.onRecordOperationAllService().then()
    },
    methods: {
        ...mapMutations('system',['SET_FLOW_ID']),
        /**
         * 返回
         */
        onBack() {
            this.$router.push('/workflow/record/list')
        },
        /**
         * 监听播放状态
         */
        onPlayStatus() {
            // this.voiceList[this.voiceInputKey].playStatus = false
            for(let i in this.voiceList){
                if(this.voiceList[i].resourceId === this.voiceInputKey){
                    this.voiceList[i].playStatus = false
                }
            }
            this.$forceUpdate()
        },
        onVisiblePlayChange(status){
            if(!status && this.voiceList.length!==0){
                this.$refs.audioPlayer.removeEventListener('ended', this.onPlayStatus,false);
            }
        },
        /**
         * 全选
         */
        handleCheckAll(){
            for(let i in this.recordInfoArray){
                if(this.checkAll){
                    this.recordInfoArray[i].type = 1
                }else{
                    this.recordInfoArray[i].type = 0
                }
                if(this.recordInfoArray[i].nodeCode === 'NODE_BATCH_OPERATION'){
                    if(this.recordInfoArray[i].type === 1){
                        if(this.recordInfoArray[i].batchOperationsType === 0){
                            for(let j in this.recordInfoArray[i].batchOperateList){
                                this.recordInfoArray[i].batchOperateList[j].type = 1
                            }
                        }
                        if(this.recordInfoArray[i].batchOperationsType === 1){
                            for(let j in this.recordInfoArray[i].batchOperateGroupList){
                                this.recordInfoArray[i].batchOperateGroupList[j].type = 1
                                for(let z in this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList){
                                    this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList[z].type = 1
                                }
                            }
                        }
                    }else{
                        if(this.recordInfoArray[i].batchOperationsType === 0){
                            for(let j in this.recordInfoArray[i].batchOperateList){
                                this.recordInfoArray[i].batchOperateList[j].type = 0
                            }
                        }
                        if(this.recordInfoArray[i].batchOperationsType === 1){
                            for(let j in this.recordInfoArray[i].batchOperateGroupList){
                                this.recordInfoArray[i].batchOperateGroupList[j].type = 0
                                for(let z in this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList){
                                    this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList[z].type = 0
                                }
                            }
                        }
                    }
                }
                if(this.recordInfoArray[i].nodeCode === 'NODE_BATCH_INPUT'){
                    if(this.recordInfoArray[i].type === 1){
                        if(this.recordInfoArray[i].batchInputOperationsType === 0){
                            for(let j in this.recordInfoArray[i].batchInputList){
                                this.recordInfoArray[i].batchInputList[j].type = 1
                            }
                        }
                        if(this.recordInfoArray[i].batchInputOperationsType === 1){
                            for(let j in this.recordInfoArray[i].batchInputGroupList){
                                this.recordInfoArray[i].batchInputGroupList[j].type = 1
                                for(let z in this.recordInfoArray[i].batchInputGroupList[j].batchInputList){
                                    this.recordInfoArray[i].batchInputGroupList[j].batchInputList[z].type = 1
                                }
                            }
                        }
                    }else{
                        if(this.recordInfoArray[i].batchInputOperationsType === 0){
                            for(let j in this.recordInfoArray[i].batchInputList){
                                this.recordInfoArray[i].batchInputList[j].type = 0
                            }
                        }
                        if(this.recordInfoArray[i].batchInputOperationsType === 1){
                            for(let j in this.recordInfoArray[i].batchInputGroupList){
                                this.recordInfoArray[i].batchInputGroupList[j].type = 0
                                for(let z in this.recordInfoArray[i].batchInputGroupList[j].batchInputList){
                                    this.recordInfoArray[i].batchInputGroupList[j].batchInputList[z].type = 0
                                }
                            }
                        }
                    }
                }
                if(this.recordInfoArray[i].nodeCode !== 'NODE_BATCH_OPERATION' && this.recordInfoArray[i].nodeCode !== 'NODE_BATCH_INPUT'){
                    if(this.checkAll){
                        this.recordInfoArray[i].type = 1
                    }else{
                        this.recordInfoArray[i].type = 0
                    }
                }
            }
            this.$forceUpdate()
        },
        /**
         * 导出验证
         */
        onExportCheck(){
            let status = false
            for(let i in this.recordInfoArray) {
                if (this.recordInfoArray[i].nodeCode !== 'NODE_BATCH_OPERATION' && this.recordInfoArray[i].nodeCode !== 'NODE_BATCH_INPUT' && this.recordInfoArray[i].type === 1) {
                    status = true
                }
                if(this.recordInfoArray[i].nodeCode === 'NODE_BATCH_OPERATION'){
                    if(this.recordInfoArray[i].batchOperationsType === 0){
                        for(let j in this.recordInfoArray[i].batchOperateList){
                            if(this.recordInfoArray[i].batchOperateList[j].type === 1){
                                status = true
                            }
                        }
                    }
                    if(this.recordInfoArray[i].batchOperationsType === 1){
                        for(let j in this.recordInfoArray[i].batchOperateGroupList){
                            for(let z in this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList){
                                if(this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList[z].type === 1){
                                    status = true
                                }
                            }
                        }
                    }
                }
                if(this.recordInfoArray[i].nodeCode === 'NODE_BATCH_INPUT'){
                    if(this.recordInfoArray[i].batchInputOperationsType === 0){
                        for(let j in this.recordInfoArray[i].batchInputList){
                            if(this.recordInfoArray[i].batchInputList[j].type === 1){
                                status = true
                            }
                        }
                    }
                    if(this.recordInfoArray[i].batchInputOperationsType === 1){
                        for(let j in this.recordInfoArray[i].batchInputGroupList){
                            for(let z in this.recordInfoArray[i].batchInputGroupList[j].batchInputList){
                                if(this.recordInfoArray[i].batchInputGroupList[j].batchInputList[z].type === 1){
                                    status = true
                                }
                            }
                        }
                    }
                }
            }
            if(!status){
                Message.warning('请勾选需要导出的内容！')
                return
            }
            this.recordModalExportVisible = true
        },
        /**
         * 导出
         */
        onExport(){
            this.recordModalLoading = true
            this.exportArray = {}
            let Array = []
            for(let i in this.recordModalExportList){
                if(this.recordModalExportList[i].type === 1){
                    Array.push(this.recordModalExportList[i].value)
                }
            }
            this.exportArray = {
                id:this.taskList.id,
                rowList:Array,
                dataList:[]
            }
            for(let i in this.recordInfoArray){
                if(this.recordInfoArray[i].nodeCode !== 'NODE_BATCH_OPERATION' && this.recordInfoArray[i].nodeCode !== 'NODE_BATCH_INPUT' && this.recordInfoArray[i].type === 1){
                    this.exportArray.dataList.push({
                        id:this.recordInfoArray[i].id,
                    })
                }
                if(this.recordInfoArray[i].nodeCode === 'NODE_BATCH_OPERATION'){
                    let arrayList = []
                    if(this.recordInfoArray[i].batchOperationsType === 0){
                        for(let j in this.recordInfoArray[i].batchOperateList){
                            if(this.recordInfoArray[i].batchOperateList[j].type === 1){
                                arrayList.push(this.recordInfoArray[i].batchOperateList[j].batchId)
                            }
                        }
                    }
                    if(this.recordInfoArray[i].batchOperationsType === 1){
                        for(let j in this.recordInfoArray[i].batchOperateGroupList){
                            for(let z in this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList){
                                if(this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList[z].type === 1){
                                    arrayList.push(this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList[z].batchId)
                                }
                            }
                        }
                    }
                    this.exportArray.dataList.push({
                        id:this.recordInfoArray[i].id,
                        batchIdList:arrayList,
                    })
                }
                if(this.recordInfoArray[i].nodeCode === 'NODE_BATCH_INPUT'){
                    let arrayList = []
                    if(this.recordInfoArray[i].batchInputOperationsType === 0){
                        for(let j in this.recordInfoArray[i].batchInputList){
                            if(this.recordInfoArray[i].batchInputList[j].type === 1){
                                arrayList.push(this.recordInfoArray[i].batchInputList[j].batchId)
                            }
                        }
                    }
                    if(this.recordInfoArray[i].batchInputOperationsType === 1){
                        for(let j in this.recordInfoArray[i].batchInputGroupList){
                            for(let z in this.recordInfoArray[i].batchInputGroupList[j].batchInputList){
                                if(this.recordInfoArray[i].batchInputGroupList[j].batchInputList[z].type === 1){
                                    arrayList.push(this.recordInfoArray[i].batchInputGroupList[j].batchInputList[z].batchId)
                                }
                            }
                        }
                    }
                    this.exportArray.dataList.push({
                        id:this.recordInfoArray[i].id,
                        batchIdList:arrayList,
                    })
                }
            }
            // console.log(this.exportArray)
            for(let i = 0 ;i< this.exportArray.dataList.length;i++){
                if(this.exportArray.dataList[i].batchIdList && this.exportArray.dataList[i].batchIdList.length === 0 ){
                    this.exportArray.dataList.splice(i,1)
                    i--
                }
            }
            this.onRecordExportService().then()
        },
        /**
         * 选择外层
         * @param item
         */
        handleCheck(item){
            if(item.nodeCode === 'NODE_BATCH_OPERATION'){
                if(item.type === 1){
                    if(item.batchOperationsType === 0){
                        for(let j in item.batchOperateList){
                            item.batchOperateList[j].type = 1
                        }
                    }
                    if(item.batchOperationsType === 1){
                        for(let j in item.batchOperateGroupList){
                            item.batchOperateGroupList[j].type = 1
                            for(let z in item.batchOperateGroupList[j].batchOperateList){
                                item.batchOperateGroupList[j].batchOperateList[z].type = 1
                            }
                        }
                    }
                }else{
                    if(item.batchOperationsType === 0){
                        for(let j in item.batchOperateList){
                            item.batchOperateList[j].type = 0
                        }
                    }
                    if(item.batchOperationsType === 1){
                        for(let j in item.batchOperateGroupList){
                            item.batchOperateGroupList[j].type = 0
                            for(let z in item.batchOperateGroupList[j].batchOperateList){
                                item.batchOperateGroupList[j].batchOperateList[z].type = 0
                            }
                        }
                    }
                }
            }
            if(item.nodeCode === 'NODE_BATCH_INPUT'){
                if(item.type === 1){
                    if(item.batchInputOperationsType === 0){
                        for(let j in item.batchInputList){
                            item.batchInputList[j].type = 1
                        }
                    }
                    if(item.batchInputOperationsType === 1){
                        for(let j in item.batchInputGroupList){
                            item.batchInputGroupList[j].type = 1
                            for(let z in item.batchInputGroupList[j].batchInputList){
                                item.batchInputGroupList[j].batchInputList[z].type = 1
                            }
                        }
                    }
                }else{
                    if(item.batchInputOperationsType === 0){
                        for(let j in item.batchInputList){
                            item.batchInputList[j].type = 0
                        }
                    }
                    if(item.batchInputOperationsType === 1){
                        for(let j in item.batchInputGroupList){
                            item.batchInputGroupList[j].type = 0
                            for(let z in item.batchInputGroupList[j].batchInputList){
                                item.batchInputGroupList[j].batchInputList[z].type = 0
                            }
                        }
                    }
                }
            }
            if(item.nodeCode !== 'NODE_BATCH_OPERATION' && item.nodeCode !== 'NODE_BATCH_INPUT'){
                if(item.type === 1){
                    item.type = 1
                }else{
                    item.type = 0
                }
            }
            let resultAll = this.recordInfoArray.some(item =>{
                if(item.type === 0){
                    return true
                }
            })
            resultAll?this.checkAll = false : this.checkAll = true
            this.$forceUpdate()
        },
        /**
         * 选择不分组
         * @param record
         */
        handleCheckBatch(record){
            if(record.nodeCode === 'NODE_BATCH_OPERATION'){
                let result = record.batchOperateList.some(item =>{
                    if(item.type === 0){
                        return true
                    }
                })
                if(result){
                    record.type = 0
                }else{
                    record.type = 1
                }
            }
            if(record.nodeCode === 'NODE_BATCH_INPUT'){
                let result = record.batchInputList.some(item =>{
                    if(item.type === 0){
                        return true
                    }
                })
                if(result){
                    record.type = 0
                }else{
                    record.type = 1
                }
            }
            this.$forceUpdate()
        },
        /**
         * 选择分组
         * @param record
         * @param group
         */
        handleCheckGroup(record,group){
            if(record.nodeCode === 'NODE_BATCH_OPERATION'){
                if(group.type === 1){
                    for(let i in group.batchOperateList){
                        group.batchOperateList[i].type = 1
                    }
                }else{
                    for(let i in group.batchOperateList){
                        group.batchOperateList[i].type = 0
                    }
                }
            }
            if(record.nodeCode === 'NODE_BATCH_INPUT'){
                if(group.type === 1){
                    for(let i in group.batchInputList){
                        group.batchInputList[i].type = 1
                    }
                }else{
                    for(let i in group.batchInputList){
                        group.batchInputList[i].type = 0
                    }
                }
            }
            if(record.nodeCode === 'NODE_BATCH_OPERATION' && record.batchOperationsType === 1){
                let resultGroup = record.batchOperateGroupList.some(item =>{
                    if(item.type === 0){
                        return true
                    }
                })
                if(resultGroup){
                    record.type = 0
                }else{
                    record.type = 1
                }
            }
            if(record.nodeCode === 'NODE_BATCH_INPUT' && record.batchInputOperationsType === 1){
                let resultGroup = record.batchInputGroupList.some(item =>{
                    if(item.type === 0){
                        return true
                    }
                })
                if(resultGroup){
                    record.type = 0
                }else{
                    record.type = 1
                }
            }
            let resultAll = this.recordInfoArray.some(item =>{
                if(item.type === 0){
                    return true
                }
            })
            resultAll?this.checkAll = false : this.checkAll = true
            this.$forceUpdate()
        },
        /**
         * 选择分组里的内容
         * @param record
         * @param group
         */
        handleCheckOption(record,group){
            console.log(record)
            if(record.nodeCode === 'NODE_BATCH_OPERATION'){
                let result = group.batchOperateList.some(item =>{
                    if(item.type === 0){
                        return true
                    }
                })
                if(result){
                    group.type = 0
                }else{
                    group.type = 1
                }
            }
            if(record.nodeCode === 'NODE_BATCH_INPUT'){
                let result = group.batchInputList.some(item =>{
                    if(item.type === 0){
                        return true
                    }
                })
                if(result){
                    group.type = 0
                }else{
                    group.type = 1
                }
            }
            if(record.nodeCode === 'NODE_BATCH_OPERATION' && record.batchOperationsType === 1){
                let resultGroup = record.batchOperateGroupList.some(item =>{
                    if(item.type === 0){
                        return true
                    }
                })
                if(resultGroup){
                    record.type = 0
                }else{
                    record.type = 1
                }
            }
            if(record.nodeCode === 'NODE_BATCH_INPUT' && record.batchInputOperationsType === 1){
                let resultGroup = record.batchInputGroupList.some(item =>{
                    if(item.type === 0){
                        return true
                    }
                })
                if(resultGroup){
                    record.type = 0
                }else{
                    record.type = 1
                }
            }
            let resultAll = this.recordInfoArray.some(item =>{
                if(item.type === 0){
                    return true
                }
            })
            resultAll?this.checkAll = false : this.checkAll = true
            this.$forceUpdate()
        },
        /**
         * 点击选项卡
         * @param n
         */
        onTabsClick(n){
            this.tabStatus = n
            if(n === 1){
                this.onRecordVideoListService().then()
            }
        },
        /**
         * 查看任务信息
         * @param row
         */
        onRecordInfoRow(row){
            this.recordInfoVisible = true
            this.recordInfoObj = row.stepContentList
        },
        /**
         * 展开收起
         * @param key
         */
        onRecordVisible(key){
            this.recordInfoArray[key].visible = !this.recordInfoArray[key].visible
            this.$forceUpdate()
        },
        /**
         * 选择的视频数据
         * @param obj
         */
        onSelectVideo(obj,key){
            this.videoSrc = ''
            this.recordSelectObj = obj
            this.videoKey = key+1
            this.$nextTick(()=>{
                this.videoSrc = obj.videoFileUrl
            })
        },
        /**
         * 查看图片
         */
        onImageAmplify(url) {
            this.recordModalTitle = '图片'
            this.recordModalVisible = true
            this.imageSrc = url
        },
        /**
         * 选择筛选条件
         * @param key
         */
        onRecordSelect(key){
            this.recordSearchList[key].type === 0?this.recordSearchList[key].type = 1:this.recordSearchList[key].type = 0
            let result = this.recordSearchList.some(item =>{
                if(item.type === 0){
                    return true
                }
            })
            result?this.recordSelectAllVisible = false:this.recordSelectAllVisible = true
            this.$forceUpdate()
        },
        /**
         * 选择筛选条件
         * @param key
         */
        onRecordExportSelect(key){
            this.recordModalExportList[key].type === 0?this.recordModalExportList[key].type = 1:this.recordModalExportList[key].type = 0
            let result = this.recordModalExportList.some(item =>{
                if(item.type === 0){
                    return true
                }
            })
            result?this.recordSelectExportAllVisible = false:this.recordSelectExportAllVisible = true
            this.$forceUpdate()
        },
        /**
         * 全选
         */
        onRecordSelectAll(){
            let result = this.recordSearchList.some(item =>{
                if(item.type === 0){
                    return true
                }
            })
            if(result){
                for(let i in this.recordSearchList){
                    this.recordSearchList[i].type = 1
                }
                this.recordSelectAllVisible = true
            }else{
                for(let i in this.recordSearchList){
                    this.recordSearchList[i].type = 0
                }
                this.recordSelectAllVisible = false
            }
        },
        /**
         * 全选
         */
        onRecordSelectExportAll(){
            let result = this.recordModalExportList.some(item =>{
                if(item.type === 0){
                    return true
                }
            })
            if(result){
                for(let i in this.recordModalExportList){
                    this.recordModalExportList[i].type = 1
                }
                this.recordSelectExportAllVisible = true
            }else{
                for(let i in this.recordModalExportList){
                    this.recordModalExportList[i].type = 0
                }
                this.recordSelectExportAllVisible = false
            }
        },
        /**
         * 选择筛选条件确定
         */
        onSearchRecord(){
            this.recordSearchArray = []
            for(let i in this.recordSearchList){
                if(this.recordSearchList[i].type === 1){
                    this.recordSearchArray.push(this.recordSearchList[i].name)
                }
            }

            this.recordSearchVisible = false
            this.onRecordInfo().then()
        },
        /**
         * 打开工作流程图
         */
        onOpenFlow(){
            if(this.flowDel === 1){
                Message.warning('该流程已删除不可打开！')
                return
            }
            this.SET_FLOW_ID(this.flowId)
            this.$router.push('/workflow/config')
        },
        /**
         * 选择筛选条件取消
         */
        onSearchRecordCancel(){
            for(let i in this.recordSearchList){
                if(this.recordSearchList[i].type === 1){
                    let result = this.recordSearchArray.some(item =>{
                        if(item === this.recordSearchList[i].name){
                            return true
                        }
                    })
                    if(!result){
                        this.recordSearchList[i].type = 0
                    }
                }
            }
            this.recordSearchVisible = false
            this.$forceUpdate()
        },
        /**
         * 触发条件验证
         * @param type
         */
        onTriggerCheck(type) {
            if(type.operationType === 0){
                this.onImageAmplify(type.followFileUrl)
            }
            if(type.operationType === 1){
                this.voiceModalVisible = true
                this.audioSrc = type.followFileUrl
                this.audioText = type.feedbackContent
            }
        },
        /**
         * 鼠标滚轮事件
         * @param e
         */
        onMousewheel(e) {
            if(e.wheelDelta > 0){
                this.onImageEnlarge()
            }else{
                this.onImageNarrow()
            }
        },
        /**
         * 记录按下的事件
         * @param e
         * @returns {{x: number, y: number}}
         */
        onMouseDown(e) {
            this.drawing = true;
            this.currentX = e.offsetX
            this.currentY = e.offsetY
        },
        /**
         * 记录抬起的事件
         * @param e
         */
        onMouseUp() {
            if (!this.drawing) { return; }
            this.drawing = false;
        },
        /**
         * 记录移动的事件
         * @param e
         */
        onMouseMove(e) {
            if (!this.drawing) { return; }
            this.imageLeft = e.clientX - this.currentX
            this.imageTop = e.clientY - this.currentY
        },
        /**
         * 图片放大比例
         */
        onImageEnlarge() {
            if((this.imageRatio + 25 ) > 1000){
                this.imageRatio = 1000
                return
            }
            this.imageRatio+=25

            this.imageLeft -= (this.imageWidth*(this.imageRatio/100) - this.imageWidth*((this.imageRatio-25)/100))/2
            this.imageTop -= (this.imageHeight*(this.imageRatio/100) - this.imageHeight*((this.imageRatio-25)/100))/2
        },
        /**
         * 图片缩小比例
         */
        onImageNarrow() {
            if((this.imageRatio - 25 ) < 25){
                this.imageRatio = 25
                return
            }
            this.imageRatio-=25
            this.imageLeft += (this.imageWidth*(this.imageRatio/100) - this.imageWidth*((this.imageRatio-25)/100))/2
            this.imageTop += (this.imageHeight*(this.imageRatio/100) - this.imageHeight*((this.imageRatio-25)/100))/2
        },
        /**
         * 还原图片
         */
        onReduction() {
            this.imageRatio = 100
            this.imageLeft = (window.innerWidth - this.imageWidth*(this.imageRatio/100))/2
            this.imageTop = (window.innerHeight - this.imageHeight*(this.imageRatio/100))/2
        },
        /**
         * 列表左移动
         */
        onImageLeft() {
            if(this.imageBigNumber === 0){
                return
            }
            this.$nextTick(()=>{
                this.offsetWidth = Math.ceil(document.getElementById('carouselId').offsetWidth)
                if(this.imageBigNumber - Math.floor(this.offsetWidth/106)<0){
                    this.imageBigNumber = 0
                }else{
                    this.imageBigNumber -= Math.floor(this.offsetWidth/106)
                }
            })
        },
        /**
         * 查看图册
         * @param row
         * @param obj
         */
        onImageSwitch(row,obj,key){
            console.log(obj)
            this.onReduction()
            this.imageBigArray = obj
            this.imageBigActive = key
            this.imageBigLookVisible = true
            this.imageObj.picUrl = row.dataResourceUrl.url
            this.imageObj.solution = row.dataResourceUrl.id
            this.onImageLoad(row.dataResourceUrl.url)
            this.onImageActive(key)
        },
        /**
         * 图片初始化
         * @param src
         */
        onImageLoad(src){
            this.imageLoading = true
            let image = new Image();
            image.src = src
            image.onload = ()=>{
                this.imageLoading = false
                if(image.height>window.innerHeight){
                    if(image.width>image.height){
                        this.imageWidth = image.height/image.width*window.innerHeight
                    }{
                        this.imageWidth = image.width/image.height*window.innerHeight
                    }
                    this.imageHeight = window.innerHeight
                }else{
                    this.imageWidth = image.width
                    this.imageHeight = image.height
                }
                this.imageLeft = (window.innerWidth- this.imageWidth)/2
                this.imageTop = (window.innerHeight- this.imageHeight)/2
            }
        },
        /**
         * 列表右移动
         */
        onImageRight() {
            this.$nextTick(()=>{
                this.offsetWidth = Math.ceil(document.getElementById('carouselId').offsetWidth)
                if(this.imageBigNumber + Math.floor(this.offsetWidth/106)>Math.floor((this.imageBigArray.length*106-this.offsetWidth)/106)){
                    this.imageBigNumber = Math.ceil((this.imageBigArray.length*106 - this.offsetWidth)/106)
                }else{
                    this.imageBigNumber += Math.floor(this.offsetWidth/106)
                }
            })
        },
        /**
         * 大图向左切换
         */
        onImageBigLeft(){
            if(this.imageBigActive === 0){
                this.imageBigActive = this.imageBigArray.length - 1
            }else{
                this.imageBigActive-=1
            }
            this.onReduction()
            this.imageObj.picUrl = this.imageBigArray[this.imageBigActive].dataResourceUrl.url
            this.imageObj.solution = this.imageBigArray[this.imageBigActive].dataResourceUrl.id
            this.onImageLoad(this.imageObj.picUrl)
            this.onImageActive(this.imageBigActive)
        },
        /**
         * 大图向右切换
         */
        onImageBigRight() {
            if(this.imageBigActive+1>=this.imageBigArray.length){
                this.imageBigActive = 0
            }else{
                this.imageBigActive+=1
            }
            this.onReduction()
            this.imageObj.picUrl = this.imageBigArray[this.imageBigActive].dataResourceUrl.url
            this.imageObj.solution = this.imageBigArray[this.imageBigActive].dataResourceUrl.id
            this.onImageLoad(this.imageObj.picUrl)
            this.onImageActive(this.imageBigActive)
        },
        /**
         * 计算列表图片位置
         * @param key
         */
        onImageActive(key) {
            this.$nextTick(()=>{
                this.offsetWidth = Math.ceil(document.getElementById('carouselId').offsetWidth)
                if(key+1>Math.ceil(this.offsetWidth/106/2)){  //让选中的图片每次保持在页面中间位置 计算方式（宽/2）向上取整
                    if((key+1)-Math.ceil(this.offsetWidth/106/2) < this.imageBigArray.length-Math.floor(this.offsetWidth/106)){
                        this.imageBigNumber = (key+1)-Math.ceil(this.offsetWidth/106/2)
                    }else{
                        this.imageBigNumber = this.imageBigArray.length-Math.floor(this.offsetWidth/106)
                    }
                }else{
                    this.imageBigNumber = 0
                }
            })
        },
        /**
         * 步骤反馈
         * @param row
         */
        onStepFeedback(row) {
            this.stepFeedbackVisible = true
            this.quickNumber = 1
            this.stepFeedbackObj = row
            if(this.stepFeedbackObj.nodeNextTriggerList){
                let obj = {}
                for(let i in this.stepFeedbackObj.nodeNextTriggerList){
                    if(this.stepFeedbackObj.nodeNextTriggerList[i].operationType === 0){
                        obj = this.stepFeedbackObj.nodeNextTriggerList[i]
                        this.stepFeedbackObj.nodeNextTriggerList.splice(i,1)
                    }
                }
                this.stepFeedbackObj.nodeNextTriggerList.unshift(obj)
            }
        },
        /**
         * 快捷反馈
         * @param row
         * @param status
         * @param batch
         */
        onQuickFeedback(row,status,batch){
            this.quickFeedbackVisible = true
            this.quickNumber = 1
            if(!batch){
                if(row.stepFeedbackList.filter(item=>item.dataType === 1 && item.batchId === '').length !==0 && status === 'camera'){
                    this.quickList = row.stepFeedbackList.filter(item=>item.dataType === 1)
                    this.voiceList = []
                    this.videoList = []
                }else{
                    this.quickList = []
                }
                if(row.stepFeedbackList.filter(item=>item.dataType === 2 && item.batchId === '').length !==0 && status === 'video'){
                    this.videoList = row.stepFeedbackList.filter(item=>item.dataType === 2)
                    this.voiceList = []
                    this.quickList = []
                }else{
                    this.videoList = []
                }
                if(row.stepFeedbackList.filter(item=>item.dataType === 3 && item.batchId === '').length !==0 && status === 'mic'){
                    this.voiceList = row.stepFeedbackList.filter(item=>item.dataType === 3)
                    this.quickList = []
                    this.videoList = []
                    for(let i in this.voiceList){
                        this.voiceList[i].visible = true
                        this.voiceList[i].playStatus = false
                    }
                    this.$nextTick(()=>{
                        this.$refs.audioPlayer.addEventListener('ended', this.onPlayStatus,false);
                    })
                }else{
                    this.voiceList = []
                }
            }else{
                if(row.stepFeedbackList.filter(item=>item.dataType === 1 && item.batchId === batch.batchId).length !==0 && status === 'camera'){
                    this.quickList = row.stepFeedbackList.filter(item=>item.dataType === 1 && item.batchId === batch.batchId)
                    this.voiceList = []
                    this.videoList = []
                }else{
                    this.quickList = []
                }
                if(row.stepFeedbackList.filter(item=>item.dataType === 2 && item.batchId === batch.batchId).length !==0 && status === 'video'){
                    this.videoList = row.stepFeedbackList.filter(item=>item.dataType === 2 && item.batchId === batch.batchId)
                    this.voiceList = []
                    this.quickList = []
                }else{
                    this.videoList = []
                }
                if(row.stepFeedbackList.filter(item=>item.dataType === 3 && item.batchId === batch.batchId).length !==0 && status === 'mic'){
                    this.voiceList = row.stepFeedbackList.filter(item=>item.dataType === 3 && item.batchId === batch.batchId)
                    this.quickList = []
                    this.videoList = []
                    for(let i in this.voiceList){
                        this.voiceList[i].visible = true
                        this.voiceList[i].playStatus = false
                    }
                    this.$nextTick(()=>{
                        this.$refs.audioPlayer.addEventListener('ended', this.onPlayStatus,false);
                    })
                }else{
                    this.voiceList = []
                }
            }
        },
        onVoiceList(key) {
            this.voiceList[key].visible = !this.voiceList[key].visible
            this.$forceUpdate()
        },
        /**
         * 播放触发录音
         * @param url
         */
        onPlay(url,row,id,status,batch) {
            if(!batch){
                if(row.stepFeedbackList.filter(item=>item.dataType === 1 && item.batchId === '').length !==0 && status === 'camera'){
                    this.quickList = row.stepFeedbackList.filter(item=>item.dataType === 1)
                    this.voiceList = []
                    this.videoList = []
                }else{
                    this.quickList = []
                }
                if(row.stepFeedbackList.filter(item=>item.dataType === 2 && item.batchId === '').length !==0 && status === 'video'){
                    this.videoList = row.stepFeedbackList.filter(item=>item.dataType === 2)
                    this.voiceList = []
                    this.quickList = []
                }else{
                    this.videoList = []
                }
                if(row.stepFeedbackList.filter(item=>item.dataType === 3 && item.batchId === '').length !==0 && status === 'mic'){
                    this.voiceList = row.stepFeedbackList.filter(item=>item.dataType === 3)
                    this.quickList = []
                    this.videoList = []
                    for(let i in this.voiceList){
                        this.voiceList[i].visible = true
                        this.voiceList[i].playStatus = false
                    }
                    this.$nextTick(()=>{
                        this.$refs.audioPlayer.addEventListener('ended', this.onPlayStatus,false);
                    })
                }else{
                    this.voiceList = []
                }
                console.log(this.voiceList)
            }else{
                if(row.stepFeedbackList.filter(item=>item.dataType === 1 && item.batchId === batch.batchId).length !==0 && status === 'camera'){
                    this.quickList = row.stepFeedbackList.filter(item=>item.dataType === 1 && item.batchId === batch.batchId)
                    this.voiceList = []
                    this.videoList = []
                }else{
                    this.quickList = []
                }
                if(row.stepFeedbackList.filter(item=>item.dataType === 2 && item.batchId === batch.batchId).length !==0 && status === 'video'){
                    this.videoList = row.stepFeedbackList.filter(item=>item.dataType === 2 && item.batchId === batch.batchId)
                    this.voiceList = []
                    this.quickList = []
                }else{
                    this.videoList = []
                }
                if(row.stepFeedbackList.filter(item=>item.dataType === 3 && item.batchId === batch.batchId).length !==0 && status === 'mic'){
                    this.voiceList = row.stepFeedbackList.filter(item=>item.dataType === 3 && item.batchId === batch.batchId)
                    this.quickList = []
                    this.videoList = []
                    for(let i in this.voiceList){
                        this.voiceList[i].visible = true
                        this.voiceList[i].playStatus = false
                    }
                    this.$nextTick(()=>{
                        this.$refs.audioPlayer.addEventListener('ended', this.onPlayStatus,false);
                    })
                }else{
                    this.voiceList = []
                }
            }

            this.audioUrl = url
            this.voiceInputKey = id
            this.$nextTick(()=>{
                for(let i in this.voiceList){
                    this.voiceList[i].playStatus = false
                }
                for(let i in this.voiceList){
                    if(this.voiceList[i].resourceId === id){
                        if(this.$refs.audioPlayer.paused){
                            this.voiceList[i].playStatus = true
                            this.$refs.audioPlayer.play()
                        }else{
                            this.voiceList[i].playStatus = false
                            this.$refs.audioPlayer.pause()
                        }
                    }
                }
                this.$forceUpdate()
            })
        },
        /**
         * 上一页
         */
        onPreviousPage(status) {
            if(this.quickNumber > 1 && this.quickNumber <= (status === 'image'?this.quickList.length:this.videoList.length)){
                this.quickNumber --
            }else{
                this.quickNumber = (status === 'image'?this.quickList.length:this.videoList.length)
            }
        },
        /**
         * 下一页
         */
        onNextPage(status) {
            if(this.quickNumber >= 1 && this.quickNumber < (status === 'image'?this.quickList.length:this.videoList.length)){
                this.quickNumber ++
            }else{
                this.quickNumber = 1
            }
        },
        /**
         * 拉取节点资源文件
         * @param row
         */
        onNodeHandle(row) {
            if(row.workFileType === 'image'){
                this.onImageAmplify(row.workFileUrl)
            }
            if(row.workFileType === 'voice'){
                this.voiceModalVisible = true
                this.audioSrc = row.workFileUrl
                this.audioText = row.operationContent
                this.inputTypeCode = row.inputTypeCode
                this.unitType = row.contentUnit
            }
        },
        onLookImage(src){
            this.viewImageVisible = true
            this.imageName = this.recordInfoObj.filter((item)=>item.type === 'text')[0].content
            this.imageSrc = src.url?src.url:src
        },
        onLookMuchImage(src){
            this.viewImageVisible = true
            this.imageName = '照片'
            // this.imageSrc = this.quickList[this.quickNumber-1].dataResourceUrl.url
            this.imageSrc = src
        },
        /**
         * 查看批量操作
         * @param list
         */
        onBatchLook(list){
            this.recordModalListVisible = true
            this.batchArray = list
        },
        /**
         * 查看批量输入
         * @param list
         */
        onBatchInputLook(list){
            this.batchInputListVisible = true
            this.batchInputArray = list
        },
        /**
         * 发送当前页
         * @param number
         */
        onSearchPage(number){
            this.recordInfoParams.currentPage = number
            this.onRecordInfo().then()
        },
        /**
         * 发送每页显示的条数
         * @param number
         */
        onSearchPageSize(number){
            this.recordInfoParams.displayNumber = number
            this.onRecordInfo().then()
        },
        /**
         * 语音组件关闭弹框时调用
         * @param status
         */
        onVisibleChange(status){
            if(!status){
                let audio = document.getElementById('audio')
                audio.pause()
                this.inputTypeCode = ''
                this.unitType = ''
            }
        },
        /**
         * 查询执行记录详情
         */
        async onRecordInfo() {
            try {
                this.recordLoading = true
                this.recordInfoArray = []
                let params = {
                    id:this.taskList.id,
                    operationList:this.recordSearchArray.join(',')
                }
                const { code,data } = await getRecordInfoService(params)
                if(code === 'SUCCESS'){
                    this.flowId = data.flowId
                    this.flowDel = data.flowDel
                    this.recordInfoArray = data.executionRecordList
                    for(let i in this.recordInfoArray){
                        this.recordInfoArray[i].type = 0
                        this.recordInfoArray[i].visible = true
                        if(this.recordInfoArray[i].nodeCode === 'NODE_PHOTO'){
                            this.recordInfoArray[i].stepFeedbackList.push({
                                batchId:'',
                                dataType:1,
                                dataResourceUrl: this.recordInfoArray[i].nodeDataImageUrl
                            })
                        }
                        if(this.recordInfoArray[i].nodeCode === 'NODE_VOICE_INPUT'){
                            this.recordInfoArray[i].stepFeedbackList.push({
                                batchId:'',
                                dataType:3,
                                dataResourceUrl: this.recordInfoArray[i].nodeDataRecordingUrl,
                                recordingTextContent:this.recordInfoArray[i].nodeDataRecordingText,
                                createTime:this.recordInfoArray[i].createTime
                            })
                        }
                        if(this.recordInfoArray[i].nodeCode === 'NODE_BATCH_INPUT'){
                            for(let j in this.recordInfoArray[i].batchInputList){
                                this.recordInfoArray[i].stepFeedbackList.push({
                                    batchId:this.recordInfoArray[i].batchInputList[j].batchId,
                                    dataType:3,
                                    dataResourceUrl: this.recordInfoArray[i].batchInputList[j].recordingFileResourceUrl,
                                    recordingTextContent:this.recordInfoArray[i].batchInputList[j].recordingTextContent,
                                    createTime:this.recordInfoArray[i].batchInputList[j].createTime
                                })
                            }
                            if(this.recordInfoArray[i].batchInputOperationsType === 0){
                                for(let j in this.recordInfoArray[i].batchInputList){
                                    this.recordInfoArray[i].batchInputList[j].type = 0
                                }
                            }
                            if(this.recordInfoArray[i].batchInputOperationsType === 1){
                                for(let j in this.recordInfoArray[i].batchInputGroupList){
                                    this.recordInfoArray[i].batchInputGroupList[j].type = 0
                                    for(let z in this.recordInfoArray[i].batchInputGroupList[j].batchInputList){
                                        this.recordInfoArray[i].batchInputGroupList[j].batchInputList[z].type = 0
                                    }
                                }
                            }
                        }
                        if(this.recordInfoArray[i].nodeCode === 'NODE_BATCH_OPERATION'){
                            if(this.recordInfoArray[i].batchOperationsType === 0){
                                for(let j in this.recordInfoArray[i].batchOperateList){
                                    this.recordInfoArray[i].batchOperateList[j].type = 0
                                }
                            }
                            if(this.recordInfoArray[i].batchOperationsType === 1){
                                for(let j in this.recordInfoArray[i].batchOperateGroupList){
                                    this.recordInfoArray[i].batchOperateGroupList[j].type = 0
                                    for(let z in this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList){
                                        this.recordInfoArray[i].batchOperateGroupList[j].batchOperateList[z].type = 0
                                    }
                                }
                            }
                        }
                    }
                    console.log(this.recordInfoArray)
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.recordLoading = false
            }catch (error){
                this.recordLoading = false
                console.log(error)
            }
        },
        /**
         * 查询执行记录视频列表
         */
        async onRecordVideoListService() {
            try {
                this.recordVideoListLoading = true
                let params = {
                    executionRecordId:this.taskId,
                }
                const { code,data } = await getRecordVideoListService(params)
                if(code === 'SUCCESS'){
                    this.recordVideoArray = data
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.recordVideoListLoading = false
            }catch (error){
                this.recordVideoListLoading = false
                console.log(error)
            }
        },
        /**
         * 查询筛选条件
         */
        async onRecordOperationAllService() {
            try {
                let params = {
                    id:this.taskList.id,
                }
                const { code,data } = await getRecordOperationAllService(params)
                if(code === 'SUCCESS'){
                    let array = []
                    for(let i in data){
                        array.push({'name':data[i],type:1})
                    }
                    this.recordSelectAllVisible = true
                    this.recordSearchList = array
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 拉取资源文件
         * @returns {Promise<void>}
         */
        async onResourcesUrl(id) {
            try {
                let params = {
                    id:id,
                }
                const {code,data} = await getImageUrlService(params);
                if(code === 'SUCCESS'){
                    if(data.fileType === 'wav'){
                        this.voiceModalVisible = true
                        this.audioSrc = data.url
                    }else{
                        this.recordModalTitle = '图片'
                        this.recordModalVisible = true
                        this.imageSrc = data.url
                    }
                }else{
                    Message.error('拉取上传参数出错，请稍后再试！')
                }
            }catch (error) {
                console.log(error)
            }
        },
        /**
         * 拉取资源视频
         * @returns {Promise<void>}
         */
        async onVideoUrl(id) {
            try {
                this.recordVideoLoading = true
                this.videoSrc = ''
                let params = {
                    id:id,
                }
                const {code,data} = await getImageUrlService(params);
                if(code === 'SUCCESS'){
                    this.videoSrc = data.url
                }else{
                    Message.error('拉取上传参数出错，请稍后再试！')
                }
                this.recordVideoLoading = false
            }catch (error) {
                this.recordVideoLoading = false
                console.log(error)
            }
        },
        /**
         * 导出作业记录
         */
        async onRecordExportService() {
            try {
                let params = {
                    id:this.exportArray.id,
                    rowList:this.exportArray.rowList,
                    dataList:this.exportArray.dataList,
                }
                const  data  = await getRecordExportService(params)
                let row = {
                    flowName:this.taskList.tasksName,
                    recordCode:this.taskList.recordCode,
                }
                downloadFile(row,data,'excel')
                this.recordModalLoading = false
                this.recordModalExportVisible = false
            }catch (error){
                this.recordModalLoading = false
                this.recordModalExportVisible = false
                console.log(error)
            }
        },
    },
    destroyed () {
    }
}
export default RecordInspectionInfo
